import React, {useEffect} from "react";
import {
    _clearToken, _getCpToken,
    _getLang,
    _getTimerStarted,
    _hideModal,
    _setTimerStarted,
    _showModal
} from "../store/system/service";
import {connect} from "react-redux";
import QnectButton from "./qnect-ui/qnect-button";
import styled from "styled-components";
import {useHistory} from "react-router-dom";
import useConfig from "./qnect-ui/qnect-config";
import {_resetUser} from "../store/user/service";
import {_resetPolicy} from "../store/policy/service";

export const StyledModalDiv = styled.div`
  width: 504px;
  text-align: center;

  div.iconDiv {
    margin-top: 40px;
  }

  div.title {
    font-family: Stag-Medium;
    font-size: 24px;
    color: #003da5;
    line-height: 36px;
    margin-top: 16px;
  }

  div.content {
    margin-top: 41px;
    margin-bottom: 40px;
    font-family: Inter-Regular;
    font-size: 18px;
    white-space: pre-wrap
  }

  div.buttonDiv {
    margin-top: 40px;
    margin-left: 161px;
    margin-right: 163px;
  }
  @media (max-width:767.95px) {
     width: auto;
     div.buttonDiv {
      margin-top: 40px;
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

const StyledQnectButton = styled(QnectButton)`
  width: 180px;
  line-height: 28px;
  font-size: 20px;
  font-weight: 500;
  font-family: Inter;
`;

export const SessionTimeout = (props) => {
    const history = useHistory();
    const cfg = useConfig(props.lang);

    useEffect(() => {
        if (props.timerStarted) {
            let timeoutObject = setTimeout(() => {
                props.showModal({
                    flat: true,
                    content: <StyledModalDiv>
                        <div className="title">
                            {cfg('labels.sessionTimeout')}
                        </div>
                        <div className="content">{cfg('labels.sessionTimeoutMessage')}</div>
                        <div className="buttonDiv">
                            <StyledQnectButton
                                field="continue"
                                onClick={() => {
                                    history.push('/login');
                                    props.hideModal();
                                    props.clearToken();
                                    props.resetPolicy();
                                    props.resetUser();
                                }}></StyledQnectButton>
                        </div>
                    </StyledModalDiv>
                });
                clearTimeout(timeoutObject);
            }, 3600000); //expire session after 1 hour. automatically logout user
            props.setTimerStarted(false, timeoutObject);
        }
    }, [props.timerStarted]);

    return null;
}

const mapStateToProps = (state) => {
    return {
        lang: _getLang(state),
        timerStarted: _getTimerStarted(state),
        cpToken: _getCpToken(state)
    }
}

const mapDispatchToProps = {
    showModal: _showModal,
    hideModal: _hideModal,
    resetUser: _resetUser,
    setTimerStarted: _setTimerStarted,
    clearToken: _clearToken,
    resetPolicy: _resetPolicy
}

export default connect(mapStateToProps, mapDispatchToProps)(SessionTimeout);

